import { useState, useRef } from "react";
import { Link } from "wouter";
import { useClerk } from "@clerk/react";

export default function Footer() {
  const { redirectToSignIn } = useClerk();
  const [clickCount, setClickCount] = useState(0);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleCopyrightClick = () => {
    const next = clickCount + 1;
    setClickCount(next);

    if (timerRef.current) clearTimeout(timerRef.current);

    if (next >= 5) {
      setClickCount(0);
      redirectToSignIn();
      return;
    }

    timerRef.current = setTimeout(() => setClickCount(0), 2000);
  };

  return (
    <footer
      className="w-full mt-auto border-t-2"
      style={{
        borderColor: 'var(--brutal-border-color)',
        backgroundColor: 'hsl(var(--foreground))',
        color: 'hsl(var(--background))',
      }}
    >
      <div className="w-full px-4 lg:px-6 py-8">
        <div className="flex flex-col sm:flex-row items-start justify-between gap-6 mb-6">
          <div>
            <span className="font-display text-xl font-black tracking-tight" data-testid="text-footer-brand">
              On A Lark
            </span>
            <p className="text-sm mt-1 opacity-70">
              Community events across Albany and the surrounding Capital District
            </p>
          </div>

          <div className="flex items-center gap-4 text-sm">
            <Link
              href="/about"
              className="min-h-[44px] inline-flex items-center px-2 -mx-2 opacity-70 hover:opacity-100 transition-opacity"
              data-testid="link-about"
            >
              About
            </Link>
            <Link
              href="/contact"
              className="min-h-[44px] inline-flex items-center px-2 -mx-2 opacity-70 hover:opacity-100 transition-opacity"
              data-testid="link-contact"
            >
              Contact
            </Link>
            <Link
              href="/privacy"
              className="min-h-[44px] inline-flex items-center px-2 -mx-2 opacity-70 hover:opacity-100 transition-opacity"
              data-testid="link-privacy"
            >
              Privacy
            </Link>
          </div>
        </div>

        <div className="pt-4 border-t text-center text-xs opacity-50" style={{ borderColor: 'hsl(var(--background) / 0.2)' }}>
          <p
            className="cursor-default select-none"
            onClick={handleCopyrightClick}
            data-testid="text-copyright"
          >
            © {new Date().getFullYear()} On A Lark Events.
          </p>
        </div>
      </div>
    </footer>
  );
}
